// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/less/userDetails.less
// module id = 580
// module chunks = 0